import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-roboto min-h-screen" }
const _hoisted_2 = { class: "overflow-hidden relative bg-white" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("source", {
  src: "/video/Getgo-Animated-Banner-1920.webm",
  type: "video/webm"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center gap-x-3 sm:gap-x-5 my-4 sm:my-8 px-3" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/add-campaign",
    class: "text-white text-sm sm:text-lg tracking-wide uppercase font-semibold sm:font-bold leading-6 text-center bg-pink w-full sm:w-72 py-4 rounded-md"
  }, " Create Campaign "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/donate",
    class: "text-dark-blue text-sm sm:text-lg tracking-wide uppercase font-semibold sm:font-bold leading-6 text-center bg-bright-green w-full sm:w-72 py-4 rounded-md"
  }, " Donate Now ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div><div class=\"relative isolate mt-0 sm:mt-0 bg-navy-blue py-6 sm:py-20\"><div class=\"mx-auto max-w-7xl px-4 sm:px-6 lg:px-8\"><div class=\"absolute -top-3 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-0 h-0 border-x-[20px] border-x-transparent border-t-[20px] border-t-white\"></div><div class=\"w-full text-center mt-4 sm:mt-0\"><p class=\"text-white text-xl sm:text-4xl font-bold tracking-tight\">A COMMUNITY UNITED BEHIND</p><p class=\"text-white text-xl sm:text-4xl font-bold tracking-tight mt-1\">QUALITY EDUCATION</p></div><div class=\"w-full text-center\"><p class=\"mt-7 sm:mt-9 font-bold text-sm sm:text-lg leading-7 text-white\"> Our mission is to empower everyone to shape the future of South Africa&#39;s children </p><p class=\"mt-2.5 font-bold text-sm sm:text-lg leading-7 text-white\"> Uniting as one South African family to provide quality education for all of South Africa&#39;s children </p></div><div class=\"mt-7 pb-4 sm:pb-0 sm:mt-10 flex justify-center\"><a href=\"/about\" class=\"text-white uppercase bg-sky-blue font-normal py-3 px-8 rounded-full cursor-pointer\">I want to know more</a></div><div class=\"absolute -bottom-2 sm:-bottom-2.5 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-0 h-0 border-x-[20px] border-x-transparent border-t-[20px] border-t-navy-blue\"></div></div></div><div class=\"relative\"><div class=\"mx-auto max-w-7xl sm:px-6 lg:px-8 pt-0 sm:pt-4\"><div class=\"flex max-w-2xl flex-col gap-16 px-6 py-9 sm:p-8 lg:mx-0 sm:max-w-none lg:flex-row lg:items-center sm:py-16 xl:gap-x-20 xl:px-20\"><div class=\"w-full\"><h2 class=\"text-3xl font-bold tracking-tight text-dark-blue sm:text-[45px] flex justify-center items-center gap-x-2 sm:gap-x-3 uppercase\"> How <img class=\"h-[27px] sm:h-[45px]\" src=\"/img/GetGo_How_It_Works_Logo.png\" alt=\"\"> Works </h2><div class=\"flex justify-center mt-8 sm:mt-12 mr-6\"><img src=\"/img/Infographic.png\" alt=\"\"></div><div class=\"mt-12 flex justify-center\"><a href=\"/how-it-works\" class=\"text-white uppercase bg-[#2DA5D9] font-normal py-3 px-8 rounded-full cursor-pointer\">I want to know more</a></div></div></div></div></div></div>", 1)

import Footer from '@/components/Atomic/AQuarks/Footer.vue'
import Sidebar from '@/components/Layouts/Sidebar.vue'
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingView',
  setup(__props) {

const isVideoEnded = ref(false);

const onVideoEnded = () => {
  isVideoEnded.value = true;
};

onMounted(() => {
  const video = document.getElementById('bannerAnimation') as HTMLVideoElement;
  
  video.addEventListener('canplaythrough', () => {
    video.play();
  });

  video.addEventListener('ended', onVideoEnded);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Sidebar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("video", {
            id: "bannerAnimation",
            playsinline: "",
            muted: "",
            class: "w-full h-full object-cover transition-opacity duration-500 ease-in-out",
            onEnded: onVideoEnded
          }, [
            _hoisted_4,
            _createTextVNode(" Your browser does not support the video tag. ")
          ], 32),
          _createElementVNode("img", {
            id: "bannerImage",
            class: _normalizeClass([{'opacity-100': isVideoEnded.value, 'opacity-0': !isVideoEnded.value}, "w-full h-full object-cover transition-opacity duration-500 ease-in-out absolute top-0 left-0"]),
            src: "/img/GetGo_Banner_High_Res.jpg",
            alt: "GetGo Banner"
          }, null, 2)
        ]),
        _hoisted_5
      ]),
      _hoisted_6,
      _createVNode(Footer)
    ])
  ], 64))
}
}

})